import { api } from '../api'

const state = {
  state: {},
  loaded: false,
  user: {
    userLicense: undefined,
    userName: undefined,
    userLogo: undefined
  },
  form: {
    cityCode: undefined,
    activityCode: undefined,
    partnersQtd: undefined,
    employeesQtd: undefined,
    revenue: undefined
  },
  contact: {
    name: undefined,
    cpf: undefined,
    phone: undefined,
    email: undefined
  }
}

const getters = {
  state: () => state.state,
  client: () => state.state.empresa,
  loaded: () => state.loaded,
  form: () => state.form,
  contact: () => state.contact,
  revenues: () => state.state.faturamentos,
  cities: () => state.state.cidades,
  serv: () => {
    if (state.state.servicos) {
      let data = []
      state.state.servicos.forEach(s => {
        let obj = {
          serv: undefined,
          servE: undefined
        }
        if (s.op_extra == 1) {
          obj.servE = s.descricao
          data.push(obj)
        } else {
          obj.serv = s.descricao
          data.push(obj)
        }
      })
      return data
    }
    return undefined
  },
  employees: () => {
    return {
      min: state.state.inicio_funcionarios,
      max: state.state.limite_funcionarios
    }
  },
  partners: () => {
    return {
      min: state.state.inicio_socios,
      max: state.state.limite_socios
    }
  },
  calcConfig: () => {
    return {
      employees: {
        min: state.state.inicio_funcionarios,
        max: state.state.limite_funcionarios
      },
      partners: {
        min: state.state.inicio_socios,
        max: state.state.limite_socios
      }
    }
  },
  calcValues: () => {
    return {
      businessOpening: state.state.valor_abertura_empresa,
      tradeBoard: state.state.valor_junta_comercial,
      license: state.state.valor_taxa_alvara,
      perEmployee: state.state.valor_funcionario,
      perPartner: state.state.valor_socio
    }
  }
}

const mutations = {
  SET_CALCULATOR_STATE (state, data) {
    console.log(data)
    state.state = data
  },
  SET_LOADED_STATE (state) {
    state.loaded = true
  },
  SET_FORM_STATE (state, payload) {
    let key = payload[0]
    let value = payload[1]
    state.form[key] = value
  },
  SET_CONTACT_STATE (state, payload) {
    let key = payload[0]
    let value = payload[1]
    state.contact[key] = value
  }
}

const actions = {
  setCalculatorState ({ commit }, that) {
    return new Promise((resolve, reject) => {
      that.$http.get(api('api/contabilidade-online/precificacao')).then(response => {
        response.data.data.servicos.sort((a, b) => (a.op_extra > b.op_extra) ? 1 : -1)
        if (response.data.status === 'FOUND') {
          commit('SET_CALCULATOR_STATE', response.data.data)
          setTimeout(() => {
            console.log('done')
            commit('SET_LOADED_STATE')
          }, 2500)
          resolve(response)
        } else {
          reject(response)
        }
      }).catch(err => {
        reject(err)
      })
    })
  },
  setFormState ({ commit }, payload) {
    commit('SET_FORM_STATE', payload)
  },
  setContactState ({ commit }, payload) {
    commit('SET_CONTACT_STATE', payload)
  }
}

export default {
  state,
  getters,
  mutations,
  actions,
  api
}
